import { createReducer } from "@reduxjs/toolkit";
import { Types } from "./Actions";
import INITIAL_STATE from "./InitialState";

export const MedicamentoReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(Types.CREAR_MEDICAMENTO_LOADING, (state) => {
      state.crearMedicamentoLoading = true;
      state.crearMedicamentoError = null;
    })
    .addCase(Types.CREAR_MEDICAMENTO_SUCCESS, (state, action) => {
      const { crearMedicamentoData } = action;
      state.crearMedicamentoData = crearMedicamentoData;
      state.crearMedicamentoLoading = false;
      state.crearMedicamentoError = null;
    })
    .addCase(Types.CREAR_MEDICAMENTO_FAILURE, (state, action) => {
      const { crearMedicamentoError } = action;
      state.crearMedicamentoData = INITIAL_STATE.crearMedicamentoData;
      state.crearMedicamentoLoading = false;
      state.crearMedicamentoError = crearMedicamentoError;
    });

  builder
    .addCase(Types.CANCELAR_MEDICAMENTO_LOADING, (state) => {
      state.cancelarMedicamentoLoading = true;
      state.cancelarMedicamentoError = null;
    })
    .addCase(Types.CANCELAR_MEDICAMENTO_SUCCESS, (state, action) => {
      const { cancelarMedicamentoData } = action;
      state.cancelarMedicamentoData = cancelarMedicamentoData;
      state.cancelarMedicamentoLoading = false;
      state.cancelarMedicamentoError = null;
    })
    .addCase(Types.CANCELAR_MEDICAMENTO_FAILURE, (state, action) => {
      const { cancelarMedicamentoError } = action;
      state.cancelarMedicamentoData = INITIAL_STATE.cancelarMedicamentoData;
      state.cancelarMedicamentoLoading = false;
      state.cancelarMedicamentoError = cancelarMedicamentoError;
    });

  builder
    .addCase(Types.GET_MEDICAMENTO_LOADING, (state) => {
      state.getMedicamentoLoading = true;
      state.getMedicamentoError = null;
    })
    .addCase(Types.GET_MEDICAMENTO_SUCCESS, (state, action) => {
      const { getMedicamentoData } = action;
      state.getMedicamentoData = getMedicamentoData;
      state.getMedicamentoLoading = false;
      state.getMedicamentoError = null;
    })
    .addCase(Types.GET_MEDICAMENTO_FAILURE, (state, action) => {
      const { getMedicamentoError } = action;
      state.getMedicamentoData = INITIAL_STATE.getMedicamentoData;
      state.getMedicamentoLoading = false;
      state.getMedicamentoError = getMedicamentoError;
    });

  builder
    .addCase(Types.CONSULTAR_MEDICAMENTOS_LOADING, (state) => {
      state.consultarMedicamentosLoading = true;
      state.consultarMedicamentosError = null;
    })
    .addCase(Types.CONSULTAR_MEDICAMENTOS_SUCCESS, (state, action) => {
      const { consultarMedicamentosData } = action;
      state.consultarMedicamentosData = consultarMedicamentosData;
      state.consultarMedicamentosLoading = false;
      state.consultarMedicamentosError = null;
    })
    .addCase(Types.CONSULTAR_MEDICAMENTOS_FAILURE, (state, action) => {
      const { consultarMedicamentosError } = action;
      state.consultarMedicamentosData =
        INITIAL_STATE.consultarMedicamentosData;
      state.consultarMedicamentosLoading = false;
      state.consultarMedicamentosError = consultarMedicamentosError;
    });

  builder
    .addCase(Types.REACTIVAR_MEDICAMENTO_LOADING, (state) => {
      state.reactivarMedicamentoLoading = true;
      state.reactivarMedicamentoError = null;
    })
    .addCase(Types.REACTIVAR_MEDICAMENTO_SUCCESS, (state, action) => {
      const { reactivarMedicamentoData } = action;
      state.reactivarMedicamentoData = reactivarMedicamentoData;
      state.reactivarMedicamentoLoading = false;
      state.reactivarMedicamentoError = null;
    })
    .addCase(Types.REACTIVAR_MEDICAMENTO_FAILURE, (state, action) => {
      const { reactivarMedicamentoError } = action;
      state.reactivarMedicamentoData = INITIAL_STATE.reactivarMedicamentoData;
      state.reactivarMedicamentoLoading = false;
      state.reactivarMedicamentoError = reactivarMedicamentoError;
    });

  builder.addCase(Types.LIMPIAR_DATOS_MEDICAMENTO_LOADING, (state) => {
    state.limpiarDatosMedicamentoLoading = true;
  });

  builder
    .addCase(Types.DESCARGAR_REPORTE_VOUCHER_LOADING, (state) => {
      state.descargarReporteVoucherLoading = true;
    })
    .addCase(Types.DESCARGAR_REPORTE_VOUCHER_SUCCESS, (state, action) => {
      const { descargarReporteVoucherData } = action;
      state.descargarReporteVoucherData = descargarReporteVoucherData;
      state.descargarReporteVoucherLoading = false;
    });

  builder
    .addCase(Types.FORM_MEDICAMENTO_DIAGNOSTICO_LOADING, (state) => {
      state.formMedicamentoDiagnosticoLoading = true;
    })
    .addCase(Types.FORM_MEDICAMENTO_DIAGNOSTICO_SUCCESS, (state, action) => {
      const { formMedicamentoDiagnosticoData } = action;
      state.formMedicamentoDiagnosticoData = formMedicamentoDiagnosticoData;
      state.formMedicamentoDiagnosticoLoading = false;
      state.getMedicamentosDiagnosticoLoading = false;
      state.modificarDiagnosticoDefinitivoLoading = false;
      state.confirmarDiagnosticoDefinitivoLoading = false;
    });

  builder.addCase(Types.GET_MEDICAMENTOS_DIAGNOSTICO_LOADING, (state) => {
    state.getMedicamentosDiagnosticoLoading = true;
  });

  builder.addCase(Types.MODIFICAR_DIAGNOSTICO_DEFINITIVO_LOADING, (state) => {
    state.modificarDiagnosticoDefinitivoLoading = true;
  });

  builder.addCase(Types.CONFIRMAR_DIAGNOSTICO_DEFINITIVO_LOADING, (state) => {
    state.confirmarDiagnosticoDefinitivoLoading = true;
  });

  builder
    .addCase(Types.BUSCAR_MEDICAMENTOS_ORDS_INFOPLAN_LOADING, (state) => {
      state.buscarMedicamentosOrdsInfoplanLoading = true;
      state.buscarMedicamentosOrdsInfoplanError = null;
    })
    .addCase(Types.BUSCAR_MEDICAMENTOS_ORDS_INFOPLAN_SUCCESS, (state, action) => {
      const { buscarMedicamentosOrdsInfoplanData } = action;
      state.buscarMedicamentosOrdsInfoplanData = buscarMedicamentosOrdsInfoplanData;
      state.buscarMedicamentosOrdsInfoplanLoading = false;
      state.buscarMedicamentosOrdsInfoplanError = null;
    })
    .addCase(Types.BUSCAR_MEDICAMENTOS_ORDS_INFOPLAN_FAILURE, (state, action) => {
      const { buscarMedicamentosOrdsInfoplanError } = action;
      state.buscarMedicamentosOrdsInfoplanData = INITIAL_STATE.buscarMedicamentosOrdsInfoplanData;
      state.buscarMedicamentosOrdsInfoplanLoading = false;
      state.buscarMedicamentosOrdsInfoplanError = buscarMedicamentosOrdsInfoplanError;
    });

  builder
    .addCase(Types.NOTIFICAR_RECLAMACION_LOADING, (state) => {
      state.notificarReclamacionLoading = true;
      state.notificarReclamacionError = null;
    })
    .addCase(Types.NOTIFICAR_RECLAMACION_SUCCESS, (state, action) => {
      const { notificarReclamacionData } = action;
      state.notificarReclamacionData = notificarReclamacionData;
      state.notificarReclamacionLoading = false;
      state.notificarReclamacionError = null;
    })
    .addCase(Types.NOTIFICAR_RECLAMACION_FAILURE, (state, action) => {
      const { notificarReclamacionError } = action;
      state.notificarReclamacionData = INITIAL_STATE.notificarReclamacionData;
      state.notificarReclamacionLoading = false;
      state.notificarReclamacionError = notificarReclamacionError;
    });
});

